import React, { useRef, useState } from 'react'
import Popup from './Popup'
import { httpClient } from '../funcs'
import Icon from './Icon'
import { useRoute } from 'react-router5'
import maxChannelIconUrl from 'images/pages/iconsV2/max.svg'
import { openInNewTab } from '../methods/openInNewTab'
import notifyUser, { notifyAboutError } from '../methods/notifyUser'
import 'pages/Styles/UIKit_v2.sass'

type Props = {
  onClose: () => void
  onSuccess?: () => void
  $store: any
  $commitToStore: (data: any) => void
  /** sign — после «Подписать и отправить»; bonus — кнопка «получить +5» в шапке */
  context?: 'sign' | 'bonus'
}

function SubscribeChannelPopup({ onClose, onSuccess, $store, $commitToStore, context = 'bonus' }: Props) {
  const $router = useRoute()
  const balance = Number($store?.balance ?? 0)
  const [busy, setBusy] = useState(false)
  const busyRef = useRef(false)
  const reduxProps = { $store, $commitToStore }

  const applyGrantedBalance = (newBalance?: number) => {
    $commitToStore({
      balance: typeof newBalance === 'number' ? newBalance : $store?.balance,
      userSession: {
        ...$store.userSession,
        received_test_balance: true,
      },
    })
  }

  const handleGetTestBalance = async () => {
    if (busyRef.current) {
      return
    }
    busyRef.current = true
    setBusy(true)
    try {
      const response = await httpClient.post('/get-test-balance')
      const data = response.data
      if (data?.success && typeof data.new_balance === 'number') {
        applyGrantedBalance(data.new_balance)
        notifyUser(reduxProps, 'Начислили 5 документов')
        onSuccess?.()
        onClose()
        return
      }
      throw new Error('Не удалось получить тестовый баланс')
    } catch (error: any) {
      const status = error?.response?.status
      const text = String(error?.response?.data ?? '')
      if (status === 400 && text.includes('уже был получен')) {
        applyGrantedBalance()
        onClose()
        return
      }
      notifyAboutError(reduxProps, error)
    } finally {
      busyRef.current = false
      setBusy(false)
    }
  }

  const handleChannelBonus = (channelUrl: string) => {
    openInNewTab(channelUrl)
    void handleGetTestBalance()
  }

  const isSign = context === 'sign'

  return (
    <Popup onClose={onClose} maxWidth="520px">
      <div className="subscribe-channel-popup-v2 ui-kit-v2">
        <div className="subscribe-channel-popup-v2__title">
          {isSign
            ? 'Чтобы отправить договор клиенту, нужен 1 документ на балансе'
            : '5 документов на баланс'}
        </div>
        <div className="subscribe-channel-popup-v2__subtitle">
          {isSign
            ? `Сейчас у вас ${balance}. Можно выбрать тариф или получить 5 документов, вступив в канал новостей сервиса.`
            : 'Вступите в канал новостей сервиса — начислим 5 документов на 30 дней. В канале новости и вебинары.'}
        </div>
        <div className="subscribe-channel-popup-v2__actions">
          {isSign && (
            <button
              className="ui-kit-v2 action-button primary"
              type="button"
              onClick={() => {
                onClose()
                $router.router.navigate('packages-v2')
              }}
            >
              Выбрать тариф
            </button>
          )}
          <button
            className="subscribe-channel-popup-v2__action-btn"
            type="button"
            aria-label="Получить 5 документов через канал Telegram"
            disabled={busy}
            onClick={() => handleChannelBonus('https://t.me/okidoki_digital_docs')}
          >
            <Icon
              icon="telegram-4"
              className="subscribe-channel-popup-v2__messenger-icon __telegram"
            />
            <span>+5 документов через Telegram</span>
          </button>
          <button
            className="subscribe-channel-popup-v2__action-btn"
            type="button"
            aria-label="Получить 5 документов через канал MAX"
            disabled={busy}
            onClick={() => handleChannelBonus('https://max.ru/id6330100935_biz')}
          >
            <img
              src={maxChannelIconUrl}
              alt=""
              className="subscribe-channel-popup-v2__messenger-icon--max"
              draggable={false}
            />
            <span>+5 документов через MAX</span>
          </button>
        </div>
      </div>
    </Popup>
  )
}

export default SubscribeChannelPopup
